import {convertToCelsius, convertToFahrenheit} from '../../Units';

/*
 * NWS heat index (Rothfusz regression with adjustments)
 * https://www.wpc.ncep.noaa.gov/html/heatindex_equation.shtml
 *
 * @param {T} : The temperature in °C
 * @param {RH} : The relative humidity in % (0 <= RH <= 100)
 * @returns : the heat index in °C
 */
export default (T: number, RH: number) => {
  const TF = convertToFahrenheit(T);

  // Simple Steadman formula, already averaged with the air temperature
  const simple = 0.5 * (TF + 61.0 + (TF - 68.0) * 1.2 + RH * 0.094);

  // Below 80°F the Rothfusz regression is not appropriate: keep the simple value
  if (simple < 80) {
    return convertToCelsius(simple);
  }

  let heatIndexInFahrenheit =
    -42.379 +
    2.04901523 * TF +
    10.14333127 * RH -
    0.22475541 * TF * RH -
    0.00683783 * TF * TF -
    0.05481717 * RH * RH +
    0.00122874 * TF * TF * RH +
    0.00085282 * TF * RH * RH -
    0.00000199 * TF * TF * RH * RH;

  if (RH < 13 && TF > 80 && TF < 112) {
    heatIndexInFahrenheit -=
      ((13 - RH) / 4) * Math.sqrt((17 - Math.abs(TF - 95.0)) / 17);
  } else if (RH > 85 && TF > 80 && TF < 87) {
    heatIndexInFahrenheit += ((RH - 85) / 10) * ((87 - TF) / 5);
  }

  return convertToCelsius(heatIndexInFahrenheit);
};
